import { Routes, Route, HashRouter } from 'react-router-dom';
import { Header } from "./components";
import Home from './pages/Home';
import Service from './pages/ServicesPage';
import Contacts from './pages/ContactPage';
import About from './pages/AboutPage';
import ProjectsPage from './pages/ProjectsPage';
import GalleryPage from './pages/GalleryPage';
import ChatWidget from './components/common/ChatWidget';

function App() {
  return (
    <HashRouter>
      <ChatWidget />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Service />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contacts" element={<Contacts />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
